import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import { noop } from 'lodash';
import React from 'react';
import { useQuery } from 'react-query';
import {
  getParbankBycriteria,
  GetParbankBycriteriaParams,
  Parbank,
} from 'services/parametersService';

export type BankListSelectProps = SelectProps<any> & {
  paramsprop?: any;
  value?: any;
  onSelected?: (bank?: Parbank) => void;
  disabled?: boolean;
  allowClear?: boolean;
  style?: any;
  defaultValue?: any;
};

const BankListSelect = ({
  paramsprop,
  value,
  onChange = noop,
  onSelected,
  allowClear,
  defaultValue,
  ...otherProps
}: BankListSelectProps) => {
  const params: GetParbankBycriteriaParams = {
    bkbic: paramsprop?.bkbic ?? '',
    bkcode: paramsprop?.bkcode ?? '',
    bkibanprefix: paramsprop?.bkibanprefix ?? '',
    bkname: paramsprop?.bkname ?? '',
    countcode: paramsprop?.countcode ?? '',
  };
  const { data: bankList, isLoading } = useQuery(
    ['getParbankBycriteria', params],
    () => getParbankBycriteria(params).then((res) => res.list || []),
    { enabled: params.countcode !== '' }
  );

  const handleChange: SelectProps<number>['onChange'] = (value, option) => {
    onChange(value, option);
    if (onSelected)
      onSelected(bankList?.find((bank) => bank.bkcode === String(value)));
  };

  return (
    <Select
      value={value}
      onChange={handleChange}
      showSearch
      {...otherProps}
      loading={isLoading}
      defaultValue={defaultValue?.priid ?? defaultValue}
      allowClear={allowClear}
    >
      {bankList?.map((bank) => (
        <Select.Option value={bank.bkcode} key={bank.bkcode}>
          {bank.bkname + ' (' + bank.bkcode + ')'}
        </Select.Option>
      ))}
    </Select>
  );
};

export default BankListSelect;
